import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-water-bodies',
  templateUrl: './water-bodies.component.html',
  styleUrls: ['./water-bodies.component.scss'],
})
export class WaterBodiesComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public subs: Subscription[] = [];
  public columnDefs;
  public rowData;
  public editPath;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userDAO: UserDAO,
    private waterBodyDAO: WaterBodyDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.editPath = 'manage/admin/water-bodies/edit';
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
    const dataSub = this.route.data.subscribe((data) => {
      this.columnDefs = this.createColumnDefs();
      this.rowData = data.waterBodies.waterBodiesResolve;
    });
    this.subs.push(dataSub);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  statusFormatter = function statusFormatter(params) {
    return params.data.activeMarket ? 'Active' : 'Inactive';
  };

  private createColumnDefs() {
    return [
      {
        headerName: 'Name',
        field: 'name',
        filter: 'text',
        sort: 'asc',
      },
      {
        headerName: 'Status',
        field: 'activeMarket',
        valueFormatter: this.statusFormatter,
      },
    ];
  }

  navigateToAdd() {
    this.router.navigate(['manage/admin/water-bodies/add-new']);
  }
}
